/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function EmojiBike({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M3.4 2.5a.6.6 0 0 1 .6-.6h3a.6.6 0 1 1 0 1.2H4a.6.6 0 0 1-.6-.6Z" /><path fill="currentColor" fillRule="evenodd" d="M10.1 4.318c0-.12.098-.218.218-.218H12a.6.6 0 1 0 0-1.2h-1.682c-.783 0-1.418.635-1.418 1.418 0 .364.028.725.082 1.082H6.1v-.9a.6.6 0 1 0-1.2 0v1.395l-.56 1.553a3.6 3.6 0 1 0 3.01 3.627l.001-.018c.126-1.31.386-2.156.775-2.81.303-.51.703-.934 1.243-1.381.118.307.256.607.416.897l.229.416a3.6 3.6 0 1 0 1.051-.58l-.229-.415a5.946 5.946 0 0 1-.736-2.866Zm.504 4.935 1.12 2.036a.6.6 0 1 0 1.052-.578l-1.12-2.037A2.404 2.404 0 0 1 14.65 11a2.4 2.4 0 1 1-4.046-1.747ZM3.75 8.6c.058 0 .115.002.172.006l-.791 2.19a.6.6 0 0 0 .564.804h2.38a2.401 2.401 0 1 1-2.325-3Zm.8 1.8h1.524A2.404 2.404 0 0 0 5.06 8.988L4.55 10.4Zm.924-2.561c.429.234.805.553 1.105.935.14-.418.31-.794.515-1.14.229-.384.494-.721.794-1.034H5.921l-.447 1.239Z" clipRule="evenodd" /></svg>;
}
;